export enum SystemRoles {
    Admin = 1, //مدير النظام
    Employee = 2, //موظف
    DeputyJointServices = 3, //نائب الخدمات المشتركة
    AdministrativeServicesManager = 4, //مدير الخدمات الادارية
    VisaApplicationDirectManager = 5, // المدير المباشر لطلب التأشيرة
    DirectorOfAdministrativeAffairsAndFacilitiesDepartment = 6, //مدير إدارة الشؤون الإدارية والمرافق
    SecuritySupervisor = 7, // مشرف الأمن
    SecurityDepartment = 8, // إدارة الأمن
    AdministrationAndFacilitiesDepartment = 9, // إدارة الشؤون الإدارية والمرافق
    HostingDirectManager = 10, //المدير المباشر لللضيافة
  }